import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'
import { Subject } from 'rxjs'

@Component({
    selector: 'app-modal-seting-mail',
    templateUrl: './modal-mail.component.html',
    styleUrls: [
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        '../../../../stagingcss/lui-select.component.css',
    ],
})
export class ModalMailComponent implements OnInit, OnDestroy {
    alertMail = true
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    routerLink
    modalChangeObserver$ = new Subject<boolean>()

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService) {
        modalService.changeEmitted$.takeUntil(this.modalChangeObserver$).subscribe(
            success => {
                if (success === 'showMoadlMail') {
                    this.alertMail = false
                    this.alertLanguage()
                }
                if (success === 'hiddenThenSaveMail') {
                    this.alertMail = true
                }
                if (success && success[0] === 'checkRotesLink') {
                    this.routerLink = success[1]
                }
            })
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if(this.modalChangeObserver$){
            this.modalChangeObserver$.next(true)
            this.modalChangeObserver$.unsubscribe()
        }
    }

    cancelAlert() {
        this.alertMail = true
        this._sharedService.emitChange('hiddenModalSaveMail')
    }

    alertDiscard() {
        this._sharedService.emitChange('statusDiscard')
        this._sharedService.emitChange('activeAlertSaveMail')
        // this.router.navigateByUrl('/app/top');
    }

    saveMail() {
        this._sharedService.emitChange('saveMail')
    }

    alertLanguage() {
        this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/mail/modal-mail.component.ts